import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class MailTemplateRule extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ key, organizationId, partnerId }) {
        if (!key) {
            throw new ArgumentError(`[Model][MailTemplateRule] organizationId and key are mandatory`);
        }

        if (partnerId) {
            // mail rules on partners
            return `/ticket/organizations/${organizationId}/partners/${partnerId}/mailing/rules/${key}`;
        }
        return `/ticket/organizations/${organizationId}/mailing/rules/${key}`;
    }
}
